const EmptyRouterView = () => /* webpackChunkName: "EmptyRouterView" */ import("./../views/medic_contra_aps/EmptyRouterView.vue");
const medicHosp = () => /* webpackChunkName: "Home" */ import("./../views/medic_contra_aps/Home.vue");
const ControllerMedic = () => /* webpackChunkName: "ControllerMedic" */ import("./../views/medic_contra_aps/telemedical/ControllerMedic.vue");
const ComptrollerMedicAps = () => /* webpackChunkName: "ComptrollerIc" */ import("./../views/medic_contra_aps/comptroller_ic/ComptrollerIc.vue");
const Document = () => /* webpackChunkName: "Document" */ import("@/views/general/Document.vue");

export const routes = [
  {
    path: "/mediContralorAps",
    component: EmptyRouterView,
    children: [
      {
        path: "",
        name: "mediContraApshome",
        component: medicHosp,
      },
      {
        path: "interconsulta-medico-contralor",
        name: "controllerMedic",
        component: ControllerMedic,
      },
      {
        path: "interconsulta-medico-contralor-aps",
        name: "comptrollerMedicAps",
        component: ComptrollerMedicAps,
      },
      {
        path: "documentacion",
        name: "comptrollerMedicApsDocumentation",
        component: Document,
      },
    ],
  },
];
